import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-gray-600 fw-semobold fs-2 p-0 m-6" }

import { ref, onMounted, computed } from "vue";
import SimpleForm2 from "@/components/SimpleForm.vue";
import { useI18n } from "vue-i18n";
import {
  HandleShowConfirmBoxType,
  ShowConfirmBoxOptionsType,
} from "@/core/types/TenantGlobalInjectionKeys";
import MsgPrompt from "@/core/plugins/MsgPrompt";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmBox',
  props: {
    isLoading: { type: Boolean },
    handleConfirm: {},
    cancel: {},
    title: {},
    confirmationPrompt: {},
    confirmTitle: {},
    waitingTitle: {},
    cancelTitle: {},
    elId: {},
    width: { default: 650 },
    confirmColor: {},
    discardColor: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const randomId = ref("");


const { t } = useI18n();

const isSubmitting = ref(false);
const confirmationText = ref<any>(null);
const confirmationTitle = ref<any>("");
const disableFooter = ref(false);

const confirmColor = ref(props.confirmColor ?? "primary");

const handleSubmitForm = ref(async () => {
  props.handleConfirm?.();
  hide();
});

const handleDiscard = ref(async () => {
  props.cancel?.();
  hide();
});
const modelRef = ref<any>();

const hide = () => {
  modelRef.value.hide();
};

const show: HandleShowConfirmBoxType = (
  handleConfirm?: () => any,
  handleCancel?: () => any,
  options?: ShowConfirmBoxOptionsType
) => {
  isSubmitting.value = false;
  handleSubmitForm.value = async () => {
    isSubmitting.value = true;
    try {
      await handleConfirm?.();
    } catch (error) {
      MsgPrompt.error(error);
    } finally {
      isSubmitting.value = false;
      hide();
    }
  };

  handleDiscard.value = async () => {
    isSubmitting.value = true;
    try {
      await handleCancel?.();
    } catch (error) {
      MsgPrompt.error(error);
    } finally {
      isSubmitting.value = false;
      hide();
    }
  };

  confirmColor.value = options?.confirmColor ?? "primary";
  confirmationText.value = options?.confirmText ?? t("tip.confirmPrompt");
  confirmationTitle.value = options?.confirmTitle ?? t("tip.confirm");
  disableFooter.value = options?.disableFooter ?? false;

  modelRef.value.show();
};

onMounted(() => {
  randomId.value = Math.random().toString(36).substring(2, 8);
});
__expose({
  hide,
  show,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleForm2, {
    ref_key: "modelRef",
    ref: modelRef,
    "append-body": "",
    title: confirmationTitle.value,
    "is-loading": _ctx.isLoading || isSubmitting.value,
    submit: handleSubmitForm.value,
    discard: handleDiscard.value,
    "save-title": props.confirmTitle ? props.confirmTitle : _ctx.$t('action.confirm'),
    "saving-title": 
      props.waitingTitle ? props.waitingTitle : _ctx.$t('action.waiting')
    ,
    "discard-title": props.cancelTitle ? props.cancelTitle : _ctx.$t('action.cancel'),
    width: props.width,
    "submit-color": confirmColor.value,
    "discard-color": props.discardColor,
    "disable-submit": props.isLoading,
    "disable-discard": props.isLoading,
    "disable-footer": disableFooter.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_1, _toDisplayString(confirmationText.value), 1)
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading", "submit", "discard", "save-title", "saving-title", "discard-title", "width", "submit-color", "discard-color", "disable-submit", "disable-discard", "disable-footer"]))
}
}

})